module.exports = __webpack_public_path__ + "03c9cbfcf92aa23ad93728922a61a9ee.svg";